export const SET_FILES = "SET_FILES";
export const ADD_FILES = "ADD_FILES";
export const REMOVE_FILE = "REMOVE_FILE";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
export const SET_EXCEEDED_FILES = "SET_EXCEEDED_FILES";

export const SET_IS_UPLOADING = "SET_IS_UPLOADING";
export const SET_DISPLAY_PROGRESS = "SET_DISPLAY_PROGRESS";
export const SET_UPLOADED_FILES = "SET_UPLOADED_FILES";

export const SET_UPLOADED_FILES_SUCCESS = "SET_UPLOADED_FILES_SUCCESS";
export const SET_UPLOAD_PROGRESS = "SET_UPLOAD_PROGRESS";
export const SET_CONSTRUCTED_FILES = "SET_CONSTRUCTED_FILES";

export const RESET_FILES = "RESET_FILES";
export const RESET_STATE = "RESET_STATE";

export const SET_FILES_ADDED = "SET_FILES_ADDED";
export const SET_ENABLE = "SET_ENABLE";

export const SET_CONFIDENTIAL_CHECKED = "SET_CONFIDENTIAL_CHECKED";
export const SET_RESTRICTED_CHECKED = "SET_RESTRICTED_CHECKED";
export const SET_CONFIDENTIAL_SELECTION = "SET_CONFIDENTIAL_SELECTION";
export const SET_RESTRICTED_SELECTION = "SET_RESTRICTED_SELECTION";
export const SET_INTERNAL_CHECKED = "SET_INTERNAL_CHECKED";
export const SET_INTERNAL_SELECTION = "SET_INTERNAL_SELECTION";
export const SET_FILE_CLASSIFICATION_SELECTION =
  "SET_FILE_CLASSIFICATION_SELECTION";
